import React, { useState, useEffect,useContext } from "react";
import { Grid, Card, CardContent, Typography, Box,Button,CardMedia } from "@mui/material";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import "./ManagerView.css";
import config from "config/config";
import Context from "context/context";
import { toast } from "react-toastify";
import ReusableTable from "components/table/table";
import Tooltip from '@mui/material/Tooltip';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import selfassessment from 'assets/images/selfassesment.png'
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from '@mui/icons-material/Cancel';
import {
    
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    
  } from "@mui/material";
  import Modal from '@mui/material/Modal';
  import { Doughnut } from "react-chartjs-2";

const ReviewAssesment = () => {
    
    const [completedEmployees, setCompletedEmployees] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCycle, setSelectedCycle] = useState(null);
    const [templateData, setTemplateData] = useState([]);
    const [isTemplateLoading, setIsTemplateLoading] = useState(false);
    const [offset, setOffset] = useState(0);
    const [searchValue, setSearchValue] = useState("");
    const [formattedTemplateData, setFormattedTemplateData] = useState([]);
    const [assignedGoals, setAssignedGoals] = useState([]);
    const { state, dispatch } = useContext(Context);
  const [count, setCount] = useState(0); // Add a count for pagination
  const [appraisalCycleId, setAppraisalCycleId] = useState(null);
  const [hasInitialized, setHasInitialized] = useState(false);
  const [isDetailView, setIsDetailView] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState({
    kraCategory: "",
    kpiName: "",
    selfRating: "",
    justification: "",
    managerRating:"",
    comments:"",
  });
  const [originalData, setOriginalData] = useState({
    selfRating: "",
    justification: "",
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [overallRating, setOverallRating] = useState(null);
  const [employeeId, setemployeeId] = useState(null);
  const rating = overallRating || 0;
  const [currentEmployeeAssessmentsId, setCurrentEmployeeAssessmentsId] = useState(null);
  const [areasOfImprovement, setAreasOfImprovement] = useState("");
const [achievements, setAchievements] = useState("");




  
    
  
    useEffect(() => {
        fetchCompletedAssessments();
    }, []);


    useEffect(() => {
    
  }, [completedEmployees]);

    const fetchCompletedAssessments = async () => {
        try {
          dispatch({ type: "SET_LOADING", payload: true });
          const url = `${config.host}/panel/pms/manager/completedAssessments`;
          const response = await fetch(url, {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          });
      
          if (!response.ok) {
            throw new Error("Error fetching completed assessments");
          }
      
          const data = await response.json();
      
        //   if (data.status === "Ok" && Array.isArray(data.data.result)) {
        //     const completedEmployees = data.data.result.map((employee) => ({
        //       employeeId: employee.employeeId,
        //       firstName: employee.firstName,
        //       role: employee.role,
        //       employeeCode: employee.employeeCode,
        //       employeeAssessmentsId: employee.employeeAssessmentsId,
        //       selfRatings:employee.selfRatings,
        //       managerRatings:employee.managerRatings,
        //       assessmentStatus: employee.assessmentStatus,
        //       managerReviewStatus:employee.managerReviewStatus,
        //     }));
        //     setCompletedEmployees(completedEmployees); // Replace with appropriate state setter or handling
        //     dispatch({ type: "SET_LOADING", payload: false });
        //   } else {
        //     console.error("Unexpected data format:", data);
        //   }
        // } catch (error) {
        //   console.error("Error fetching completed assessments:", error);
        // } finally {
        //   dispatch({ type: "SET_LOADING", payload: false });
        // }
        if (data.status === "Ok") {
          if (data.data?.error) {
            // Display error message from response
            toast.error(data.data.error);
            dispatch({ type: "SET_LOADING", payload: false });
            return;
          }
    
          if (Array.isArray(data.data.result) && data.data.result.length > 0) {
            const completedEmployees = data.data.result.map((employee) => ({
              employeeId: employee.employeeId,
              firstName: employee.firstName,
              role: employee.role,
              employeeCode: employee.employeeCode,
              employeeAssessmentsId: employee.employeeAssessmentsId,
              selfRatings: employee.selfRatings,
              managerRatings: employee.managerRatings,
              assessmentStatus: employee.assessmentStatus,
              managerReviewStatus: employee.managerReviewStatus,
            }));
            setCompletedEmployees(completedEmployees);
          } else {
            // Handle empty or unexpected result array
            toast.warn("No completed assessments found.");
            console.warn("Unexpected data format or empty result array:", data.data.result);
          }
        } else {
          // Handle unexpected statuses
          toast.error("Failed to fetch completed assessments. Please try again.");
          console.error("Unexpected status:", data.status);
        }
      } catch (error) {
        console.error("Error fetching completed assessments:", error);
        toast.error("Error fetching completed assessments. Please try again.");
      } finally {
        dispatch({ type: "SET_LOADING", payload: false });
      }
      };


    
    
      const tableDatakpi = assignedGoals.map((employee,index) => [
        index+1, // S.No
        employee.kraCategory,
        employee.kpiName,
        employee.weightage,
        <Tooltip title="Click to give review" key={employee.id}>
          <span className="jobType">
            <RemoveRedEyeIcon
              style={{ color: '#E97000', cursor: 'pointer' }}
              onClick={() => handleViewkpi(employee)} // Pass the entire employee object
            />
          </span>
        </Tooltip>, 
      ]);
    
     
  
    
  
    const handleBack = () => {
      setIsDetailView(false)
    };
   
    
      const handleModalClose = () => {
        setOpenModal(false);
       
      };

      const handleModalSavenew = async () => {

        if (!achievements.trim() || !areasOfImprovement.trim()) {
          toast.error("Achievements and Area of Improvement cannot be empty.");
          return; // Stop the process if either of the fields is empty
        }
        const requestBody = {
          employeeAssessmentsId: currentEmployeeAssessmentsId, // Replace with the actual ID
          employeeId: employeeId, // Replace with the actual employee ID
          overAllRating: rating, // Bind with the current rating state
          achievements: achievements, // Value from achievements state
          areaOfImprovements: areasOfImprovement, // Value from areasOfImprovement state
        };
        
        dispatch({ type: "SET_LOADING", payload: true });
      
        try {
          const response = await fetch(`${config.host}/panel/pms/manager/saveReview`, {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });
      
          const result = await response.json();
      
          if (response.ok && result.status === "Ok") {
            console.log("Save Successful:", result);
            toast.success("Review saved successfully!");
            handleCloseModalnew(); // Close the modal
            setIsDetailView(false);
            setemployeeId("")
            setAchievements("")
            setCurrentEmployeeAssessmentsId("")
            setAreasOfImprovement("")
            fetchCompletedAssessments()

            
          dispatch({ type: "SET_LOADING", payload: false });
          } else {
            console.error("Save Failed:", result);
            toast.error("Failed to save review. Please try again.");
            dispatch({ type: "SET_LOADING", payload: false });
          }
        } catch (error) {
          console.error("Error while saving review:", error);
          toast.error("An error occurred. Please try again later.");
          dispatch({ type: "SET_LOADING", payload: false });
        }
      };
      

      const handleModalSave = async () => {
        console.log("Modal Data:", modalData); 
       
        if (!modalData.managerRating || modalData.managerRating === "Pending" || modalData.managerRating.trim() === "") {
          toast.error("Please provide a Manager Rating.");
          return;
        }
      
        if (! modalData.comments ||  modalData.comments.trim() === "") {
          toast.error("Please provide comments.");
          return;
        }
          
          dispatch({ type: "SET_LOADING", payload: true }); // Set loading state
      
        try {
          // Call the Save Self Review API
          const response = await fetch(`${config.host}/panel/pms/manager/review`, {
            method: "POST",
            credentials: "include", // Include credentials if required
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              employeeAssessmentsId: modalData.employeeAssessmentsId,
              employeeId: modalData.employeeId,
              managerRating: modalData.managerRating,
              managerComments: modalData.comments,
              kpiKraId: modalData.kpiKraId,
            }),
          });
      
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to save the Manager-review");
          }
      
          const data = await response.json();
      
          if (data.status === "Ok") {
            toast.success("Manager-review saved successfully!");
            console.log("Saved Employee Assessment ID:", modalData.employeeAssessmentsId);
            handleViewClick(modalData.employeeAssessmentsId);
      
            
          } else {
            toast.error("Failed to save the Manager-review.");
          }
        } catch (error) {
          console.error("Error saving self-review:", error);
          toast.error(`Error: ${error.message}`);
        } finally {
          dispatch({ type: "SET_LOADING", payload: false }); // Reset loading state
          handleModalClose(); // Close the modal
        }
      };


      const handleViewkpi = (employee) => {
        if (!employee) {
          console.error("Invalid employee data:", employee);
          return;
        }
      
        setModalData({
          kraCategory: employee.kraCategory || "",
          kpiName: employee.kpiName || "",
          selfRating: employee.selfRating || "", // Fallback if selfRating is undefined
      justification: employee.justification || "", 
          employeeAssessmentsId: employee.employeeAssessmentsId, // Add assessment ID
        kpiKraId: employee.id,
        comments:employee.managerComments || "",
        managerRating:employee.managerRating || "",
        });
        setOpenModal(true);
      };

      const handleViewClick = async (employeeAssessmentsId) => {
        // const { employeeAssessmentsId } = employee;
        setCurrentEmployeeAssessmentsId(employeeAssessmentsId);
      
        try {
          // Show a loading spinner if needed
          dispatch({ type: "SET_LOADING", payload: true });
      
          // Make the API call
          const response = await fetch(
            `${config.host}/panel/pms/assignedGoals?employeeAssessmentsId=${employeeAssessmentsId}`,
            {
              method: "GET",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
      
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to fetch assigned goals");
          }
      
          const data = await response.json();
      
          if (data.status === "Ok" && data.data.length > 0) {


            const formattedData = data.data.flatMap((employee, index) =>
              employee.kpiDetails.map((kpi, kpiIndex) => ({
                id: kpi.kpiKraDetailsId,
                employeeAssessmentsId: employee.employeeAssessmentsId,
                index: kpiIndex + 1, // Serial number for each KPI
                kpiName: kpi.kpiName,
                weightage: kpi.weightage,
                kraCategory: kpi.kraCategory,
                templateName: employee.templateName,
                selfRating: kpi.selfRating , 
                justification: kpi.justification ,
                managerComments:kpi.managerComments,
                managerRating:kpi.managerRating,
              }))
            );
           

            const goalsData = data.data[0]; // Assuming only one result per employeeAssessmentsId
            console.log("Fetched Assigned Goals:", formattedData);
      
            // Store or display the fetched data
            
            setAssignedGoals(formattedData); // Example: Store KPI details
            setIsDetailView(true);
            // setTemplateName(goalsData.templateName); // Example: Store template name
            // setOpenModal(true); // Example: Open a modal to display the details
          } else {
            toast.error("No data found for this employee.");
          }
        } catch (error) {
          console.error("Error fetching assigned goals:", error);
          toast.error(`Error: ${error.message}`);
        } finally {
          dispatch({ type: "SET_LOADING", payload: false });
        }
      };

      const getColor = (rating) => {
        if (rating >= 4) return "#4CAF50"; // Green
        if (rating >= 3) return "#FF9800"; // Orange
        return "#F44336"; // Red
      };
      

      
      
      

      const tableDataCompleted = completedEmployees.map((employee, index) => [
        index + 1, // S.No
        employee.firstName,
        employee.employeeCode,
        employee.role,
        employee.selfRatings,
        employee.managerRatings,

        employee.managerReviewStatus == "Completed" ? (
          <Tooltip title="Review Completed" key={`${employee.id}-completed`}>
            <CheckCircleIcon style={{ color: 'green' }} />
          </Tooltip>
        ) : (
          <Tooltip title="Review Pending" key={`${employee.id}-pending`}>
            <CancelIcon style={{ color: 'red' }} />
          </Tooltip>
        ),
        
        <Tooltip title="Click to give review" key={employee.id}>
          <span className="jobType">
            <RemoveRedEyeIcon
              style={{ color: '#E97000', cursor: 'pointer' }}
              onClick={() => {
                if (employee.managerReviewStatus === "Completed") {
                  // Show toast message when the manager review is already completed
                  toast.info("Manager review has already completed");
                } else {
                  // Proceed with the normal view click behavior
                  handleViewClick(employee.employeeAssessmentsId); 
                }
              }}
            />
          </span>
        </Tooltip>,
      ]);

      const handleNextClick = async (employeeAssessmentsId) => {
        console.log("Employee Assessment ID:", employeeAssessmentsId);


        const incompleteKPIs = assignedGoals.filter(goal => !goal.managerRating || !goal.managerComments);

    if (incompleteKPIs.length > 0) {
     console.log("incompleteKPIs",incompleteKPIs.length)
        // Display an error message
        toast.error("Please ensure all KPIs have manager ratings and comments.");
       
        return; // Prevent further execution if validation fails
    }

        dispatch({ type: "SET_LOADING", payload: true });

        
        try {
            const response = await fetch(
                `${config.host}/panel/pms/manager/overAllRatings?employeeAssessmentsId=${employeeAssessmentsId}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );
    
            if (!response.ok) {
                throw new Error("Failed to fetch overall rating");
                dispatch({ type: "SET_LOADING", payload: false });
            }
    
            const data = await response.json();
    
            if (data.status === "Ok" && data.data) {
                const { overAllRatings } = data.data;
                const {employeeId}=data.data
    
                if (overAllRatings !== undefined) {
                    setOverallRating(overAllRatings);
                    setemployeeId(employeeId)
                    setIsModalVisible(true); // Ensure modal is shown only after setting the rating
                    console.log("Overall Rating:", overAllRatings);
                    dispatch({ type: "SET_LOADING", payload: false });
                } else {
                    console.error("No overall ratings found in the response.");
                    dispatch({ type: "SET_LOADING", payload: false });
                }
            } else {
                console.error("Error fetching rating data:", data);
                dispatch({ type: "SET_LOADING", payload: false });
            }
        } catch (error) {
            console.error("API Error:", error);
            dispatch({ type: "SET_LOADING", payload: false });
        }
    };
    
    const handleCloseModalnew = () => {
      setIsModalVisible(false);
  };
      
  
   
  
    return (
      <Box
        sx={{
          padding: 4,
          backgroundColor: "#f9f9f9",
          borderRadius: 2,
          boxShadow: 1,
        }}
      >
        <Typography
          variant="h5"
          align="center"
          className="self-title"
          
        >
          {isDetailView ? "Review Goals" : "Self Assessment Completed Employees"}
        </Typography>
  
        {isDetailView ? (
      <>
        <Button
          variant="contained"
          onClick={handleBack}
          sx={{ marginBottom: 2 }}
        >
          Back
        </Button>
        <ReusableTable
          create={
            <Button className="AddKrabutton" onClick={() => handleNextClick(currentEmployeeAssessmentsId)} >
              Next
            </Button>
          }
          data={tableDatakpi}
          count={assignedGoals.length}
          offset={offset}
          setOffset={setOffset}
          limit="25"
          setSearchValue={setSearchValue}
          heading={["S.No", "KRA", "KPI", "Weightage", "Action"]}
        />
      </>
    ) : tableDataCompleted.length > 0 ? (
       <ReusableTable
          
          data={tableDataCompleted}
          count={tableDataCompleted.length}
          offset={offset}
          setOffset={setOffset}
          limit="25"
          setSearchValue={setSearchValue}
          heading={["S.No", "Name", "Employee Id", "Role","Self Rating","Manager Rating","Reviewed", "Open"]}
        />
     
    ) : (
      <Typography variant="body1" align="center">
        No appraisal cycles available.
      </Typography>
    )}


<Dialog
  open={isModalVisible}
  onClose={handleCloseModalnew}
  classes={{
    paper: "modal-overall-container",
  }}
>
  <div>
    <DialogTitle className="modal-overall-title">Overall Rating</DialogTitle>
    <DialogContent>
      <Grid container spacing={4} sx={{ px: 4, pb: 5, mt: 2 }}>
        {/* Doughnut Chart */}
        <Grid item xs={12} sm={6}>
  <div style={{ position: "relative", width: "300px", height: "300px" }}>
    {/* Doughnut Chart */}
    <Doughnut
      data={{
        labels: ["Rating"],
        datasets: [
          {
            data: [rating, 5 - rating],
            backgroundColor: [getColor(rating), "#ddd"], // Chart colors
          },
        ],
      }}
      options={{
        cutout: "70%", // Controls the inner radius size
        plugins: {
          tooltip: { enabled: false }, // Disable tooltips
        },
        responsive: true,
        maintainAspectRatio: false, // Ensures chart doesn't distort
      }}
      className="modal-overall-chart"
    />

    {/* Central Text */}
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)", // Center the text
        fontSize: "20px",
        fontWeight: "bold",
        color: "#000", // Text color
      }}
    >
      {rating}/5
    </div>
  </div>
</Grid>

        {/* Text Areas: Areas of Improvement and Achievements */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          {/* Areas of Improvement */}
          <Box className="label">
            Areas of Improvement <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8", mt: 1 }}
            id="areasOfImprovement"
            name="areasOfImprovement"
            placeholder="Areas of Improvement"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={areasOfImprovement}
  onChange={(e) => setAreasOfImprovement(e.target.value)}
          />

          {/* Achievements */}
          <Box className="label" sx={{ mt: 3 }}>
            Achievements <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8", mt: 1 }}
            id="achievements"
            name="achievements"
            placeholder="Achievements"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={achievements}
            onChange={(e) => setAchievements(e.target.value)}
          />
        </Grid>
      </Grid>
    </DialogContent>

    <DialogActions>
      <Button onClick={handleCloseModalnew} className="self-cancelButton">
        Close
      </Button>
      <Button onClick={handleModalSavenew} className="self-saveButton">
        submit
      </Button>
    </DialogActions>
  </div>
</Dialog>






     <Dialog
  open={openModal}
  onClose={handleModalClose}
  maxWidth={false} // Disable the default width restrictions
  classes={{
    paper: "manager-modal-paper",
  }}
>
  <DialogTitle className="self-modal-title">Manager Rating</DialogTitle>
  <Grid container spacing={2} sx={{ pl: 6, pr: 5, pb: 5, mt: 2 }}>
    {/* KRA */}
    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
      <Box className="label">KRA <span style={{ color: "red" }}>*</span></Box>
      <TextField
        sx={{ border: "1px solid #B2D4F8" }}
        id="kraCategory"
        name="kraCategory"
        placeholder="Enter KRA"
        variant="outlined"
        fullWidth
        value={modalData.kraCategory}
        InputProps={{ readOnly: true }} // Make it readonly
      />
    </Grid>

    {/* KPI */}
    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
      <Box className="label">KPI <span style={{ color: "red" }}>*</span></Box>
      <TextField
        sx={{ border: "1px solid #B2D4F8" }}
        id="kpiName"
        name="kpiName"
        placeholder="Enter KPI"
        variant="outlined"
        fullWidth
        value={modalData.kpiName}
        InputProps={{ readOnly: true }} // Make it readonly
      />
    </Grid>

    {/* Self Rating */}
    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
      <Box className="label">Self Rating <span style={{ color: "red" }}>*</span></Box>
      <TextField
        sx={{ border: "1px solid #B2D4F8", backgroundColor: "#f9f9f9" }}
        id="selfRating"
        name="selfRating"
        value={modalData.selfRating}
        variant="outlined"
        fullWidth
        InputProps={{ readOnly: true }} // Make it readonly
      />
    </Grid>

    {/* Justification */}
    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
      <Box className="label">Justification <span style={{ color: "red" }}>*</span></Box>
      <TextField
        sx={{ border: "1px solid #B2D4F8", backgroundColor: "#f9f9f9" }}
        id="justification"
        name="justification"
        value={modalData.justification}
        variant="outlined"
        fullWidth
        multiline
        rows={4}
        InputProps={{ readOnly: true }} // Make it readonly
      />
    </Grid>

    {/* Manager Rating */}
    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
      <Box className="label">Manager Rating <span style={{ color: "red" }}>*</span></Box>
      <FormControl fullWidth>
        <Select
          labelId="manager-rating-label"
          id="managerRating"
          style={{ border: "2px solid #B2D6F8" }}
          value={modalData.managerRating}
          onChange={(e) => setModalData((prev) => ({ ...prev, managerRating: e.target.value }))}
          displayEmpty
        >
          <MenuItem value="" disabled>Select rating</MenuItem>
          <MenuItem value="Outstanding">Outstanding</MenuItem>
          <MenuItem value="Exceeds Expectation">Exceeds Expectation</MenuItem>
          <MenuItem value="Met Expectation">Met Expectation</MenuItem>
          <MenuItem value="Met Expectation, but needs improvement">
            Met Expectation, but needs improvement
          </MenuItem>
          <MenuItem value="Does not meet expectation">
            Does not meet expectation
          </MenuItem>
        </Select>
      </FormControl>
    </Grid>

    {/* Comments */}
    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
      <Box className="label">Comments<span style={{ color: "red" }}>*</span></Box>
      <TextField
        sx={{ border: "1px solid #B2D4F8" }}
        id="comments"
        name="comments"
        placeholder="Enter Comments"
        variant="outlined"
        fullWidth
        multiline
        rows={4}
        value={modalData.comments}
        onChange={(e) => setModalData((prev) => ({ ...prev, comments: e.target.value }))}
      />
    </Grid>
  </Grid>

  <DialogActions>
    <Button onClick={handleModalClose} className="self-cancelButton">
      Cancel
    </Button>
    <Button onClick={handleModalSave} className='self-saveButton'>
      Save
    </Button>
  </DialogActions>
</Dialog>




    </Box>
  );
};

export default ReviewAssesment;
    
